import { route } from '@betterment/js-runtime';

import brochureUrl from './brochureUrl';
import { employerScopedRoute } from './pathHelpers';

export const urlBuilder = {
  // routes sorted alphabetically
  appHome: route('', []),
  compliance: route('', ['compliance']),
  currentEmployer: route('', ['current_employers', { param: 'employerId' }]),
  dashboard: route('', ['/dashboard']),
  employee: route('', ['employees', { param: 'employeeId' }]),
  employees: route('', ['employees']),
  employers: route('', ['employers']),
  fiveTwoNine: route('', ['/five_two_nines/overview']),
  help: route('', ['help']),
  home: route('', ['home']),
  onboarding: route('', ['employer_onboarding_tasks']),
  payroll: route('', ['payroll_overview']),
  plan: route('', ['/plan']),
  profile: route('', ['profile']),
  profileEmailPreferencesEdit: route('', ['profile', 'email_preferences', 'edit']),
  reports: employerScopedRoute(['reports']),
  reportsNew: employerScopedRoute(['reports', 'new']),
  reportsSuccess: employerScopedRoute(['reports', 'success']),
  resources: route('', ['resources']),
  resourcesBenefitsGuide: route('', ['resources', 'benefits_guide']),
  resourcesContributionRateGuide: route('', ['resources', 'contribution_rate_guide']),
  resourcesDistributionGuide: route('', ['resources', 'distribution_guide']),
  resourcesMakingMostOf401k: route('', ['resources', 'making_most_of_401k']),
  resourcesNewEmployeeWebinar: route('', ['resources', 'new_employee_webinar']),
  resourcesProductDemo: route('', ['resources', 'product_demo']),
  resourcesRolloverGuide: route('', ['resources', 'rollover_guide']),
  resourcesTipsForIncreasingParticipation: route('', ['resources', 'tips_for_increasing_participation']),
  settings: route('', ['settings']),
  signOut: route('', ['plan_managers', 'sign_out']),
  support: route('', ['/support']),
  tasks: route('', ['/tasks']),
  unallocatedFundsAutomationEdit: route('', ['unallocated_funds_automation', 'edit']),

  // For setting up the graphQL client
  graphQL: route('', ['/graphql']),

  // Brochure links
  getCoaching() {
    return brochureUrl('/work/coaching');
  },
  getEmployeeEngagementPlaybook() {
    return brochureUrl('/work/employee/employee-engagement-playbook');
  },
  getEmployeeFinancialPlanningHub() {
    return brochureUrl('/resources/employees/financial-planning-hub');
  },
  getManageYour401kPlan() {
    return brochureUrl('/work/manage-your-401k-plan');
  },
  getResources() {
    return brochureUrl('/work/resources');
  },
  get401kGlossary() {
    return brochureUrl('/work/resources/401k-glossary');
  },
  getComplianceCycleGuide() {
    return brochureUrl('/hubfs/PDFs/b4b/employer-dashboard/Betterment at Work - Compliance Cycle One-pager.pdf');
  },
  getEngagementStarterKit() {
    return brochureUrl('/work/resources/the-401k-employee-engagement-starter-kit');
  },
  getFiduciaryResponsibilitiesGuide() {
    return brochureUrl('/work/resources/guide-to-meeting-your-401k-fiduciary-responsibilities');
  },
  getOnboardingHelpCenter() {
    return brochureUrl('/help/tag/onboarding');
  },
  getReportsOverviewGuide() {
    return brochureUrl('/hubfs/PDFs/b4b/employer-dashboard/Betterment at Work - Dashboard Reports Overview.pdf');
  },
  getUnallocatedFundsGuide() {
    return brochureUrl('/work/resources/what-are-unallocated-funds');
  },

  // Download links
  getDeconversionPackageDownload() {
    return '/plan_reports/deconversion_package';
  },
  getInvestmentActivityPackageDownload(reportId: string) {
    return `/plan_reports/investment_activity_packages/${reportId}`;
  },
  getReportCsvDownload(reportId: string) {
    return `/reports/${reportId}.csv`;
  },
  getSignablePackageDownload(signablePackageId: string) {
    return `/signable_package_download/${signablePackageId}`;
  },
  getSignablePackageSuccess(signablePackageId: string, returnToPath?: string) {
    return `/signable_packages/${signablePackageId}/success${returnToPath ? `?returnTo=${encodeURIComponent(returnToPath)}` : ''}`;
  },
};
